import { cx, css } from '@emotion/css';
import { Select, SelectProps } from 'antd';
import { useTranslate } from '@tolgee/react';
import { useCallback } from 'react';

export interface ReceptionMinuteSelectProps extends SelectProps {
  optHours?: number[];
}

const defaultOptHours = [0.5, 1, 2, 4, 6, 8, 12, 24, 48, 72, 96, 120, 144, 168];

const SelectWrap = css`
  margin: 0 8px;
  display: inline-block;
`;

export function useGetHourLabel() {
  const { t } = useTranslate();

  const getHourLabel = useCallback(
    (hour: number) => {
      let label = `${hour}${t('translation.小时')}`;
      const valueInMinute = Math.ceil(hour * 60);
      if (hour < 1) {
        label = `${valueInMinute}${t('translation.分钟')}`;
      } else if (hour >= 24) {
        label = `${Math.floor(hour / 24)}${t('translation.天')}`;
      }
      return {
        value: valueInMinute,
        label,
      };
    },
    [t],
  );

  return {
    t,
    getHourLabel,
  };
}

const ReceptionMinuteSelect = ({
  className,
  optHours = defaultOptHours,
  ...props
}: ReceptionMinuteSelectProps) => {
  const { getHourLabel } = useGetHourLabel();
  return (
    <Select
      className={cx(SelectWrap, className)}
      {...props}
      optionLabelProp="label"
      options={optHours.map(getHourLabel)}
    />
  );
};
export default ReceptionMinuteSelect;
